import React from 'react';
import PropTypes from 'prop-types';
import { AVAILABLE_GENERAL_REPORTS } from '../../graphql/reports';
import ReportsPopup from './ReportsPopup';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import Spinner from '../Spinner';
import Error from '../errors/Error';

GeneralReportsMenu.propTypes = {
    onCancel: PropTypes.func.isRequired,
};

function GeneralReportsMenu(props) {
    const {
        onCancel,
    } = props;
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(AVAILABLE_GENERAL_REPORTS);
    let result;
    if (loading) {
        result = <Spinner className="general-reports-loading" fixed />;
    } else if (error) {
        result = <Error className="general-reports-error" error={error} />;
    } else {
        result = (
            <ReportsPopup
                reports={data.availableGeneralReports.availableReports}
                deliveryYears={data.availableGeneralReports.deliveryYears}
                members={data.availableGeneralReports.availableMembers}
                onCancel={onCancel}
            />
        );
    }
    return result;
}

export default GeneralReportsMenu;
